import React from "react";

// Floating "Complimentary Gap Analysis" call-to-action, fixed on every page.
// Sits bottom-left so it never collides with the WhatsApp FAB (bottom-right).
export default function GapFloat() {
  return (
    <a
      href="/gap-analysis"
      className="gap-fab"
      aria-label="Contact us for a complimentary Gap Analysis"
      data-testid="gap-analysis-float"
    >
      <span className="gap-fab-ic" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </span>
      <span className="gap-fab-txt">Free Gap Analysis</span>
    </a>
  );
}
